
import mixins from "vue-typed-mixins";
import Common from "../mixins/Common";
import RadioButton from "primevue/radiobutton";
import { AffiliateSubscription } from "@/interfaces/AffiliateSubscription";

export default mixins(Common).extend({
  name: "SubscriptionSelector",

  // Vue 2.7: map the default v-model to selectedSub + "input"
  model: { prop: "selectedSub", event: "input" },

  props: {
    affiliateSubscriptions: { type: Array, required: true },

    /** Selected subscription object (controlled by parent via v-model) */
    selectedSub: { type: Object, default: null },

    /** Billing mode (controlled by parent via .sync) */
    isMonthly: { type: Boolean, default: true },
  },

  computed: {
    // v-model proxy for selectedSub
    selectedSubProxy: {
      get(): any {
        return (this as any).selectedSub;
      },
      set(v: any) {
        (this as any).$emit("input", v); // updates parent v-model
        (this as any).$emit("selection", { selected: v, isMonthly: (this as any).isMonthly });
      },
    },

    // .sync proxy for isMonthly
    isMonthlyProxy: {
      get(): boolean {
        return (this as any).isMonthly;
      },
      set(v: boolean) {
        (this as any).$emit("update:isMonthly", v); // updates parent via .sync
        (this as any).$emit("selection", { selected: (this as any).selectedSub, isMonthly: v });
      },
    },

    sortedAffiliateSubscriptions(): AffiliateSubscription[] {
      const list = (this as any).affiliateSubscriptions as AffiliateSubscription[] | null;
      if (!list) return [];
      return list.filter((sub) => !sub.isLegacy).sort((a, b) => a.displayOrder - b.displayOrder);
    },
  },

  methods: {
    isSelected(s: any) {
      const cur = (this as any).selectedSub as any;
      if (!s || !cur) return false;
      if (cur === s) return true;
      if (cur.id != null && s.id != null) return String(cur.id) === String(s.id);
      return false;
    },
    setIsMonthly(v: boolean) {
      (this as any).isMonthlyProxy = v;
    },
    selectPlan(s: any) {
      (this as any).selectedSubProxy = s;
    },

    isFree(s: any) {
      const mp = Number(s && s.monthlyPrice) || 0;
      const yp = Number(s && s.yearlyPrice) || 0;
      return mp === 0 && yp === 0;
    },
    formatPrice(price: any) {
      const num = Number(price) || 0;
      return Number.isInteger(num) ? num : num.toFixed(2);
    },
    safeIncludes(s: any) {
      try {
        const raw = s && s.subscriptionIncludesJSON;
        const data = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(data) ? data : [];
      } catch {
        return [];
      }
    },
  },

  components: { RadioButton },
});
